/**
 * Pool immagini editoriali 6amico — asset AI proprietari in /public/img/6amico.
 * Fallback Pexels solo per regioni/mondo dove non c’è ancora asset dedicato.
 */

/** @param {string} file basename senza estensione */
export function aiImage(file) {
  return `/img/6amico/${file}.png`;
}

/** @param {number|string} id @param {number} [w] */
export function pexels(id, w = 800) {
  return `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;
}

/** Chiavi tematiche → URL. */
export const SIXAMICO_MEDIA = {
  borghi: aiImage("6amico-borghi"),
  comuni: aiImage("6amico-borghi"),
  /** Hub «Mappa del mondo» — planisfero / rete globale (≠ metropoli). */
  mappaMondo: pexels(1125295, 1600),
  mappe: pexels(1125295, 1600),
  mappaGlobale: pexels(1125295, 1600),
  /** Mappa operativa in loco (sentieri, bici, geofence) — distinta dal collage hub Italia. */
  esploraMappa: aiImage("6amico-tour"),
  podcast: aiImage("6amico-podcast"),
  natura: aiImage("6amico-natura"),
  parchi: aiImage("6amico-natura"),
  mare: aiImage("6amico-mare"),
  mareAdriatico: aiImage("6amico-mare"),
  tour: aiImage("6amico-tour"),
  tourHero: aiImage("6amico-tour"),
  rafting: aiImage("6amico-tour"),
  bike: aiImage("6amico-tour"),
  trekking: aiImage("6amico-tour"),
  terme: aiImage("6amico-terme"),
  termeHero: aiImage("6amico-terme"),
  spa: aiImage("6amico-terme"),
  nautica: aiImage("6amico-nautica"),
  nauticaHero: aiImage("6amico-nautica"),
  porto: aiImage("6amico-nautica"),
  vela: aiImage("6amico-nautica"),
  fiere: aiImage("6amico-tour"),
  fiereHero: aiImage("6amico-tour"),
  vinitaly: aiImage("6amico-tour"),
  designFair: aiImage("6amico-tour"),
  travelExpo: aiImage("6amico-tour"),
  spiritualita: aiImage("6amico-spiritualita"),
  spiritualitaHero: aiImage("6amico-spiritualita"),
  chiesa: aiImage("6amico-spiritualita"),
  cammino: aiImage("6amico-spiritualita"),
  /** Directory «Città del mondo» — skyline metropoli (≠ mappa mondiale). */
  mondo: pexels(2901209, 1600),
  gemellaggi: aiImage("6amico-borghi"),
  enogastronomia: aiImage("6amico-borghi"),
  eventi: aiImage("6amico-borghi"),
  unesco: aiImage("6amico-natura"),
  montagna: aiImage("6amico-natura"),
  slowTravel: aiImage("6amico-tour"),
  gargano: aiImage("6amico-mare"),
  storia: aiImage("6amico-storia"),
  governance: aiImage("6amico-governance"),
  community: aiImage("6amico-community"),
  eventiHub: aiImage("6amico-eventi"),
  weekend: aiImage("6amico-weekend"),
  vetrina: aiImage("6amico-vetrina"),
  mondoGlobal: pexels(2901209, 1600),
  homeDefault: aiImage("6amico-borghi"),
  regionBasilicata: pexels(4577808, 1600),
  regionCalabria: pexels(2382685, 1600),
  regionCampania: pexels(415999, 1600),
  regionEmilia: pexels(1179225, 1600),
  regionFriuli: pexels(2113554, 1600),
  regionLazio: pexels(2225442, 1600),
  regionLiguria: pexels(1450363, 1600),
  regionLombardia: pexels(2363, 1600),
  regionMarche: pexels(1175961, 1600),
  regionMolise: pexels(14367021, 1600),
  regionPiemonte: pexels(4206181, 1600),
  regionPuglia: pexels(3467149, 1600),
  regionSardegna: pexels(2603464, 1600),
  regionSicilia: pexels(3214973, 1600),
  regionToscana: pexels(1546166, 1600),
  regionTrentino: pexels(2113556, 1600),
  regionUmbria: pexels(4128412, 1600),
  regionValleAosta: pexels(2455398, 1600),
  regionVeneto: pexels(161901, 1600),
  worldParis: pexels(2901209, 1600),
  worldTokyo: pexels(2901209, 1600),
  worldNyc: pexels(2901209, 1600),
  worldDubai: pexels(2901209, 1600),
  worldSydney: aiImage("6amico-mare"),
  worldRio: aiImage("6amico-natura"),
  worldCairo: aiImage("6amico-spiritualita"),
  worldBerlin: aiImage("6amico-governance"),
  worldLondon: pexels(2901209, 1600),
};

/** @param {keyof typeof SIXAMICO_MEDIA} key @param {number} [_w] */
export function media(key, _w) {
  return SIXAMICO_MEDIA[key] || SIXAMICO_MEDIA.homeDefault;
}

export const PORTAL_IMAGES_BY_PATH = {
  "/mappa-del-mondo": SIXAMICO_MEDIA.mappaMondo,
  "/comuni": SIXAMICO_MEDIA.borghi,
  "/archivio-podcast": SIXAMICO_MEDIA.podcast,
  "/parchi": SIXAMICO_MEDIA.parchi,
  "/mare-costa": SIXAMICO_MEDIA.mare,
  "/tour-escursioni": SIXAMICO_MEDIA.tour,
  "/terme-benessere": SIXAMICO_MEDIA.terme,
  "/turismo-nautico": SIXAMICO_MEDIA.nautica,
  "/fiere-convegni": SIXAMICO_MEDIA.fiere,
  "/spiritualita": SIXAMICO_MEDIA.spiritualita,
  "/mondo": SIXAMICO_MEDIA.mondoGlobal,
};

export function portalImage(path) {
  return PORTAL_IMAGES_BY_PATH[path] || SIXAMICO_MEDIA.homeDefault;
}
